/* NatPat Summer Starter Kit – vanilla JS
   1. FAQ accordion
   2. Smooth scroll for #-links
   3. Sticky bottom CTA bar
*/

(function () {
  "use strict";

  /* ── 1. FAQ accordion ───────────────────────────────────────────────────── */
  function initAccordion() {
    var items = document.querySelectorAll('[data-slot="accordion-item"]');
    items.forEach(function (item) {
      var trigger = item.querySelector('[data-slot="accordion-trigger"]');
      var content = item.querySelector('[data-slot="accordion-content"]');
      if (!trigger || !content) return;

      trigger.addEventListener("click", function () {
        var isOpen = item.getAttribute("data-state") === "open";

        // Close all other items first
        items.forEach(function (otherItem) {
          if (otherItem === item) return;
          var otherContent = otherItem.querySelector('[data-slot="accordion-content"]');
          var otherTrigger = otherItem.querySelector('[data-slot="accordion-trigger"]');
          otherItem.setAttribute("data-state", "closed");
          if (otherContent) {
            otherContent.setAttribute("data-state", "closed");
            otherContent.style.display = "none";
          }
          if (otherTrigger) {
            otherTrigger.setAttribute("data-state", "closed");
            otherTrigger.setAttribute("aria-expanded", "false");
          }
        });

        // Toggle this item
        if (isOpen) {
          item.setAttribute("data-state", "closed");
          content.setAttribute("data-state", "closed");
          content.style.display = "none";
          trigger.setAttribute("data-state", "closed");
          trigger.setAttribute("aria-expanded", "false");
        } else {
          item.setAttribute("data-state", "open");
          content.setAttribute("data-state", "open");
          content.style.display = "block";
          trigger.setAttribute("data-state", "open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  /* ── 2. Smooth scroll for anchor links ──────────────────────────────────── */
  function initSmoothScroll() {
    document.addEventListener("click", function (e) {
      var target = e.target.closest("a[href]");
      if (!target) return;
      var href = target.getAttribute("href");
      if (!href) return;

      // Scroll to top for bare # links
      if (href === "#") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      // Scroll to section for #id links
      if (href.startsWith("#") && href.length > 1) {
        var el = document.querySelector(href);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  }

  /* ── 3. Sticky bottom CTA bar ───────────────────────────────────────────── */
  function initStickyBar() {
    // The bar is the fixed bottom div already in the HTML
    var bar = document.querySelector(".fixed.inset-x-0.bottom-0");
    if (!bar) return;

    var SHOW_AFTER = 300; // px scrolled

    function updateBar() {
      if (window.scrollY > SHOW_AFTER) {
        bar.style.display = "";
      } else {
        bar.style.display = "none";
      }
    }

    // Hide initially if page is at top
    updateBar();
    window.addEventListener("scroll", updateBar, { passive: true });
  }

  /* ── init ───────────────────────────────────────────────────────────────── */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAccordion();
      initSmoothScroll();
      initStickyBar();
    });
  } else {
    initAccordion();
    initSmoothScroll();
    initStickyBar();
  }
})();
